import { InjectionToken } from '@angular/core';
import { CpRgLimitsParallelTimeValuesApiKind } from '@bcf-vanilla-ts-v1-configurators/tokens/rg-limits-parallel/types';
import { RgLimitsNonParallelPredefinedAmounts } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const RG_LIMITS_PARALLEL_TIME_VALUES_API_KIND: InjectionToken<CpRgLimitsParallelTimeValuesApiKind> =
  new InjectionToken<CpRgLimitsParallelTimeValuesApiKind>('rgLimitsParallelTimeValuesApiKind', {
    factory: () => 'hours'
  });

// eslint-disable-next-line @typescript-eslint/naming-convention
export const RG_LIMITS_NON_PARALLEL_PREDEFINED_AMOUNTS: InjectionToken<RgLimitsNonParallelPredefinedAmounts> =
  new InjectionToken<RgLimitsNonParallelPredefinedAmounts>('rgLimitsNonParallelPredefinedAmounts');
